import * as Yup from 'yup';
import {DayOfWeek} from '../../../../types/pricing';

export interface ScheduleFormType {
    userId: number | string;
    startDay: string | DayOfWeek;
    startHour: number | string;
    startMinute: number | string;
    stopDay: string | DayOfWeek;
    stopHour: number | string;
    stopMinute: number | string;
    type: boolean;
}

export const scheduleFormSchema = Yup.object().shape({
    userId: Yup.number().required('schemaRequiredUser'),
    startDay: Yup.string().required('schemaRequiredStartDay'),
    startHour: Yup.string().required('schemaRequiredStartHour'),
    startMinute: Yup.string().required('schemaRequiredStartMinute'),
    stopDay: Yup.string().required('schemaRequiredStopDay'),
    stopHour: Yup.string().required('schemaRequiredStopHour'),
    stopMinute: Yup.string().required('schemaRequiredStopMinute'),
});
